export const firebaseConfig = {
    apiKey: "AIzaSyD2XGhDlQh04QtRhf8dW4xmSpDMrgXU5Y4",
    authDomain: "ecommerce-demo-261102.firebaseapp.com",
    databaseURL: "https://ecommerce-demo-261102.firebaseio.com",
    projectId: "ecommerce-demo-261102",
    storageBucket: "ecommerce-demo-261102.appspot.com",
    messagingSenderId: "292727796110",
    appId: "1:292727796110:web:cb207b95c910004246b4df"
}
